const authRoutes = ['login', 'register']

export default {
  methods: {
    pagePath(path) {
      return this.localePath(`auth-${path}`, this.$i18n.locale)
    },
    hasRoute(form) {
      return authRoutes.includes(form)
    },
    canRedirect(form) {
      return this.hasRoute(form) &&
        this.$route.path != this.pagePath(form)
    },
    redirect(path) {
      this.$router.push({ path: this.pagePath(path) })
    }
  }
}
